import React, {Fragment} from 'react';
import { Link } from '@material-ui/core';

import WireImage from '../../assets/images/wire.jpg';
import WomanImage from '../../assets/images/woman.jpg';
import CameraImage from '../../assets/images/camera.jpg';
import SmartImage from '../../assets/images/smart_home.jpg';
import FeatureFlip from '../FeatureFlip';

const headerSubItems = [
  {
    text: () =>
      (<Fragment>
        <i className="fal fa-piggy-bank" />
        <p>Preferred pricing for Nest Users</p>
      </Fragment>),
  },
  {
    text: () =>
      (<Fragment>
        <i className="fal fa-trophy-alt" />
        <p>Pros are rated 4.7 out of 5 on average!</p>
      </Fragment>),
  },
  {
    text: () =>
      (<Fragment>
        <i className="fal fa-clock" />
        <p>24/7 Customer Support</p>
      </Fragment>),
  },
]

export const COPY_HEADER_MAIN = [
  {
    title: 'Get peace of mind with Handy',
    text: 'Don\'t worry! If a pro determines that your system is working properly and no additional work is needed, Handy will refund the full cost of the visit.*',
    subText: <FeatureFlip feature='coSchedulingEnabled'
                          on='*Limited time pricing. Refund only applies if your visit was scheduled through Google Nest HVAC monitoring alerts.'
                          off='*Limited time pricing. Refund only applies if your visit was scheduled through Google Nest alerts.' />,
    img: WireImage,
    subItems: headerSubItems,
  }
];

export const COPY_HEADER_SMALLS = [
  {
    key: '1',
    title: 'Book and Manage Online',
    text: () => 'Booking with Handy is easy. You can reschedule, change details, or cancel on the Handy website or app any time up to 24 hours before the start of your appointment time.',
    img: WomanImage,
  },
  {
    key: '2',
    title: 'Leave it to the Pros',
    text: () => 'A thorough system check up requires skills, tools, and knowledge that only experienced HVAC technicians have. They show up with everything they need to get the job done.',
    img: CameraImage,
  },
  {
    key: '3',
    title: 'Happiness Guaranteed',
    text: () =>
      <Fragment>
        Your happiness is our goal. If you’re not happy, we’ll work to make it right. Our friendly customer service agents are available 24 hours a day, 7 days a week. The <Link rel="noopener noreferrer" target="_blank" href="https://www.handy.com/handy-guarantee">Handy Happiness Guarantee</Link> only applies when you book and pay for a service directly through the Handy Platform.
      </Fragment>
    ,
    img: SmartImage,
  },
];
